export const quiz = [
    {
        id : 1,
        pertanyaan : "Perusahaan perumahaan reminz ingin membuat rumah dengan dua tipe. Rumah tipe A membutuhkan tanah seluas 20 x 10 m2 dan rumah tipe B membutuhkan tanah seluas 15 x 8 m2. Luas tanah yang tersedia 1 hektar. Jika banyak rumah tipe A adalah x buah dan bangunan rumah tipe B adalah y buah, model matematika dari permasalahan tersebut adalah ....",
        options : [
            { 
                title : "5x + 3y ≤ 100; x, y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "3x + 5y ≤ 100; x, y ≥ 0",
                op :"b",
                correct : false,
            },
            { 
                title : "5x + 3y ≤ 250; x, y ≥ 0",
                op :"c",
                correct : true,
            },
            { 
                title : "5x + 3y ≤ 300; x, y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "3x + 5y ≤ 300; x, y ≥ 0",
                op :"e",
                correct : false,
            },
        ],                
    },
    {
        id : 2,
        pertanyaan : "Seorang siswa mempunyai uang Rp15.000,00. Ia ingin membelanjakan uangnya dengan dua jenis, yaitu pulpen dan buku. Pulpen yang harganya Rp2.500,00 persatuan dibeli sebanyak x satuan dan buku yang harganya Rp5.000,00 persatuan dibeli sebanyak y satuan. Model matematika dari permasalahan tersebut adalah ….",
        options : [
            { 
                title : "x + 2y ≤ 6",
                op :"a",
                correct : true,
            },
            { 
                title : "x + 6y ≤ 2",
                op :"b",
                correct : false,
            },
            { 
                title : "2x + 2y ≤ 6",
                op :"c",
                correct : false,
            },
            { 
                title : "2x + y ≤ 6",
                op :"d",
                correct : false,
            },
            { 
                title : "2x + 6y ≤ 6",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 3,
        pertanyaan : " Sebuah industri kecil memproduksi 2 jenis barang A dan B menggunakan 2 mesin M1 dan M2. Untuk membuat barang A mesin M1 beroperasi 2 menit dan mesin M2 beroperasi 4 menit. Adapun untuk membuat barang B mesin M1 beroperasi 8 menit dan mesin M2 beroperasi 4 menit. Mesin M1 dan M2 masing-masing beroperasi tidak lebih dari 8 jam setiap hari. Model matematika dari permasalahan di atas adalah ...",
        options : [
            { 
                title : "	x + 4y ≥ 240; x + y ≥ 120; x ≥ 0; y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "	x + 4y ≤ 240; x + y ≥ 120; x ≥ 0; y ≥ 0",
                op :"b",
                correct : false,
            },
            { 
                title : "	x + 4y ≥ 240; x + y ≤ 120; x ≥ 0; y ≥ 0.",
                op :"c",
                correct : false,
            },
            { 
                title : "	x - 4y ≥ 240; x - y ≥ 120; x ≥ 0; y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "x + 4y ≤ 240; x + y ≤ 120; x ≥ 0; y ≥ 0",
                op :"e",
                correct : true,
            },
        ],  
    },
    {
        id : 4,
          pertanyaan : "Pengusaha perumahan membangun dua macam tipe rumah. Untuk tipe 21 luas tanah yang diperlukan 60m2 dan tipe 36 luas tanah 90m2. Jika banyaknya rumah yang akan dibangun tidak lebih dari 800 unit dan luas tanah yang tersedia adalah 54.000 m2, model matematika dari permasalahan tersebut adalah ...",
        options : [
            { 
                title : "2x + 3y ≤ 54.000; x + y ≤ 800; x ≥ 0; y ≥ 0.",
                op :"a",
                correct : false,
            },
            { 
                title : "2x + 3y ≤ 1.800; x + y ≤ 800; x ≥ 0; y ≥ 0",
                op :"b",
                correct : true,
            },
            { 
                title : "3x + 2y ≤ 800 ; x + y ≤ 54.000; x ≥ 0; y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "2x + 3y ≤ 800; x + y ≤ 1.800; x ≥ 0; y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "3x + 2y ≤ 54.000; x + y ≤ 800; x ≥ 0; y ≥ 0",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 5,
        pertanyaan : "Harga pembungkus lilin A Rp2.000,00 dan lilin B Rp1.000,00. Jika pedagang hanya mempunyai modal Rp800.000,00 dan kiosnya hanya mampu menampung 500 bungkus lilin, model matematika dari permasalahan tersebut adalah ...",
        options : [
            { 
                title : "	x + y ≥ 500; 2x + y ≥ 800; x ≥ 0; y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "	x + y ≤ 500; 2x + y ≤ 800; x ≥ 0; y ≥ 0.",
                op :"b",
                correct : true,
            },
            { 
                title : "	x - y ≥ 500; 2x - y ≥ 800; x ≥ 0; y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "	2x + y ≥ 800; x + y ≥ 500; x ≥ 0; y ≥ 0.",
                op :"d",
                correct : false,
            },
            { 
                title : "	x + 2y ≥ 800; x + 2y ≥ 500; x ≥ 0; y ≥ 0",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id: 6,
        pertanyaan : " Amanda membeli 5 kg tepung dan 6 kg pisang. Amanda harus membayar Rp45.000,00. Sementara itu, Manopo membeli 4 kg tepung dan 7 kg pisang. Manopo harus membayar Rp32.000,00. Jika harga 1 kg tepung adalah x dan 1 kg pisang adalah y, maka model matematika untuk masalah tersebut adalah ...",
        options : [
            { 
                title : "5x + 6y ≤ 45.000; 7x + 4y ≤ 32.000; x ≥ 0; y ≥ 0;",
                op :"a",
                correct : false,
            },
            { 
                title : "5x + 6y ≤ 32.000; 4x + 7y ≤ 45.000; x ≥ 0; y ≥ 0;",
                op :"b",
                correct : false,
            },
            { 
                title : "6x + 5y ≤ 45.000; 7x + 4y ≤ 32.000; x ≥ 0; y ≥ 0;",
                op :"c",
                correct : false,
            },
            { 
                title : "5x - 6y ≤ 45.000; 4x - 7y ≤ 32.000; x ≥ 0; y ≥ 0;",
                op :"d",
                correct : false,
            },
            { 
                title : "5x + 6y ≤ 45.000; 4x + 7y ≤ 32.000; x ≥ 0; y ≥ 0;",
                op :"e",
                correct : true,
            }
        ],  
    },
    {
        id : 7,
        pertanyaan : "Amin merupakan seorang pemborong pengecatan rumah. Amin mempunyai persediaan 80 kaleng cat warna putih dan 60 kaleng cat warna abu-abu. Amin mendapatkan tawaran untuk mengecat ruang tamu dan kamar tidur. Setelah dihitung, ternyata 1 ruang tamu menghabiskan 2 kaleng cat putih dan 1 kaleng cat abu-abu. Adapun kamar tidur menghabiskan masng-masing 1 kaleng. Jika banyaknya ruang tamu dinyatakan dengan x dan banyaknya kamar tidur dinyatakan dengan y, maka model matematika dari pernyataan tersebut adalah ...",
        options : [
            { 
                title : "x + y ≤ 80; 2x + y ≥ 60; x ≥ 0; y ≥ 0.",
                op :"a",
                correct : false,
            },
            { 
                title : "x + y ≥ 80; 2x + y ≤ 60; x ≥ 0; y ≥ 0",
                op :"b",
                correct : false,
            },
            { 
                title : "2x + y ≤ 80; x + y ≤ 60; x ≥ 0; y ≥ 0",
                op :"c",
                correct : true,
            },
            { 
                title : "x - y ≤ 80; 2x - y ≥ 60; x ≥ 0; y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "2x + y ≤ 80; x - y ≥ 60; x ≥ 0; y ≥ 0",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 8,
        pertanyaan : "Syaiful merupakan seorang pengusaha roti ingin membuat 2 jenis roti. Roti jenis I memerlukan 200 gram tepung dan 350 gram gula, roti jenis II memerlukan 250 gram tepung dan 450 gram gula. Syaiful memiliki persediaan 14 kg tepung dan 20 kg gula. Jika x dan y berturut-turut menyatakan banyak roti jenis I dan banyak roti jenis II, model matematika dari permasalahan tersebut adalah ...",
        options : [
            { 
                title : "200x + 350y ≤ 14.000; 250x + 450y ≤ 20.000; x ≥ 0; y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "200x + 250y ≤ 14.000; 350x + 450y ≤ 20.000; x ≥ 0; y ≥ 0",
                op :"b",
                correct : true,
            },
            { 
                title : "200x + 350y ≥ 14.000; 250x - 450y ≤ 20.000; x ≥ 0; y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "350x + 200y ≤ 20.000; 250x + 450y ≤ 14.000; x ≥ 0; y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "200x + 450y ≤ 14.000; 250x + 350y ≤ 20.000; x ≥ 0; y ≥ 0",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 9,
        pertanyaan : "Fahmi merupakan seorang pedagang sepeda motor akan membelanjakan uangnya sebesar Rp110.000.000,00. Gudang tempat menaruh sepeda motor tersebut hanya dapat memuat 52 sepeda motor. Sepeda motor bekas jenis astrea berharga Rp2.000.000,00 per unit dan harga sepeda motor bekas jenis supra berharga Rp2.200.000,00 per unit. Jika banyaknya sepeda motor jenis astrea dinyatakan dengan x dan banyaknya sepeda motor jenis supra dinyatakan dengan y, maka model matematikanya adalah ...",
        options : [
            { 
                title : "x + y ≤ 55; 10x + 11y ≤ 520; x,y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "x + y ≤ 55; 11x + 10y ≤ 520; x,y ≥ 0",
                op :"b",
                correct : false,
            },
            { 
                title :"x + y ≤ 55; 10x + 11y ≤ 550; x,y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "x + y ≤ 52; 11x + 10y ≤ 550; x,y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "x + y ≤ 52; 10x + 11y ≤ 520; x,y ≥ 0",
                op :"e",
                correct : true,
            }
        ],  
    },
    {
        id : 10,
        pertanyaan : "Pemeliharaan suatu kebun membutuhkan pupuk yang mengandung unsur N, P, dan K masing-masing 20 kg, 24 kg, dan 24 kg. Pupuk jenis A mengandung unsur N, P, dan K masing-masing 10 kg , 4 kg, dan 2kg. Pupuk jenis B mengandung unsur N, P, dan K masing-masing 2 kg, 4 kg, dan 8kg tiap karung. Jika banyak pupuk jenis A dinyatakan dengan x karung dan pupuk jenis B dinyatakan dengan y karung, model matematikanya adalah ...",
        options : [
            { 
                title : "5x + y ≤ 10; x + y ≤ 6; x + 4y ≤ 12; x, y ≥ 0",
                op :"a",
                correct : true,
            },
            { 
                title : "5x + 2y ≤ 10; x + 2y ≤ 6; x + 4y ≤ 12; x, y ≥ 0",
                op :"b",
                correct : false,
            },
            { 
                title : "5x + y ≤ 10; x + 2y ≤ 6; x + 4y ≤ 12; x, y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "5x + y ≤ 10; 2x + y ≤ 6; x + 4y ≤ 12; x, y ≥ 0",
                op :"d",
                correct : false,
            },
            { 
                title : "5x + 2y ≤ 10; x + 2y ≤ 6; x + 4y ≤ 12; x, y ≥ 0",
                op :"e",
                correct : false,
            }
        ],  
    },    

];